import React from "react"
import { T } from "../../traks"

export const nonPremiumDetails = [
    {
        title: <T>Setups</T>,
        entries: [
        <T>Option to play for up to 365 days</T>, 
        <T>Option for up to 30 participants in your games</T>, 
        <T>Choose your starting capital</T>, 
        <T>Reflect your trading volume</T>, 
        <T>Reflect your trading volume</T>, 
        <T>Maximum amount per security</T>,
        <T>Commission fees</T>,
    ]
    }, {
        title: <T>Investment opportunities</T>,
        entries: [
            <T>Trading on the Danish market</T>
        ]
    }, {
        title: <T>Support & flexibility</T>,
        entries: [
            <T>Email support</T>,
            <T>No binding commitment</T>
        ]
    }
]

export const premiumDetails = [
    {
        title: <T>Expanded setups</T>,
        entries: [
            <T>Option for more than 30 participants in your games</T>,
            <T>Option to compete on risk-weighted returns</T>,
            <T>Information and financial statements on assets</T>,
            <T>Option to set a trading limit for participants</T>,
        ]
    },
    {
        title: <T>Expanded Investment Opportunities</T>,
        entries: [
            <T>Trading in all countries – DK, SE, DE, US, ISL, FIN</T>,
            <T>Option for games with ETFs, funds, crypto, bonds, and commodities</T>,
        ]
    },
    {
        title: <T>User Management</T>,
        entries: [
            <T>Remove unwanted participants from your contest</T>,
            <T>Disburse or withdraw capital from participants</T>,
            <T>Close registrations at the deadline</T>,
            <T>Option for students to log in without an email (available only for primary schools)</T>,
        ]
    },
    {
        title: <T>Support & Flexibility</T>,
        entries: [
            <T>Telephone support</T>,
            <T>No binding commitment</T>,
        ]
    },
]


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumDetails.js